import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[oneComponentContainer]'
})
export class DynamicComponentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
